/**
 * ICAO Annex 14 aerodrome reference code letters, by wingspan.
 * A < 15 m, B < 24 m, C < 36 m, D < 52 m, E < 65 m, F < 80 m.
 */
export type IcaoCode = "A" | "B" | "C" | "D" | "E" | "F";

const BANDS: Array<{ code: IcaoCode; from: number; to: number }> = [
  { code: "A", from: 0, to: 15 },
  { code: "B", from: 15, to: 24 },
  { code: "C", from: 24, to: 36 },
  { code: "D", from: 36, to: 52 },
  { code: "E", from: 52, to: 65 },
  { code: "F", from: 65, to: 80 },
];

/** Code letter of an aircraft with this wingspan. */
export function icaoCodeForWingspan(wingspan: number): IcaoCode {
  return (BANDS.find((b) => wingspan < b.to) ?? BANDS[BANDS.length - 1]!).code;
}

/**
 * Largest code a stand takes. The stand limit is inclusive ("up to 36 m"),
 * so a 36 m stand is Code C: it takes all Code C aircraft and no Code D.
 */
export function icaoCodeForStand(maxWingspan: number): IcaoCode {
  let code: IcaoCode = "A";
  for (const b of BANDS) if (maxWingspan > b.from) code = b.code;
  return code;
}

/** Wingspan limit (exclusive) of a code letter. */
export function icaoCodeLimit(code: IcaoCode): number {
  return BANDS.find((b) => b.code === code)!.to;
}
